import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";

export const _LandingHeaderRoot = styled("section")<{}>(() => {
  return css`
    .landing-header__title {
      // margin-bottom: 8px;
      // @media ${responsiveMap.maxLg} {
      //   margin-bottom: 21px;
      // }
    }
  `;
});

export const _LandingHeaderCtaWrapper = styled("div")(() => {
  return {
    marginTop: 31,
  };
});

export const _LandingHeaderSvgUploadLogo = styled("img")`
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  max-width: 350px;

  @media ${responsiveMap.mobile} {
    max-width: 300px;
  }
`;
